<div>
  <div class="header_exit">
    <div class="header_title">{{ data.name }}</div>
    <button class="close-button" mat-icon-button [mat-dialog-close]="true" aria-label="Close">
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>
  <div class="description">{{ 'SHARED.COMPONENTS.FUNDER_CARD.GRANTMAKERS.DESCRIPTION' | translate }}</div>
</div>
<ng-container *ngIf="data.grantmakers.length; else nolist">
  <div class="title">{{ 'SHARED.COMPONENTS.FUNDER_CARD.GRANTMAKERS.NAME' | translate }}</div>
  <mat-dialog-content>
    <div class="grantee-card" *ngFor="let gm of data.grantmakers">
      <img
        [defaultImage]="'https://fdi-files.s3.amazonaws.com/public/image-placeholder.png'"
        [lazyLoad]="gm?.grantMakerPhoto?.url"
        alt="profile-image"
        width="120px"
        height="120px"
      />
      <div class="info">
        <div class="fullname-title">{{ gm.grantMakerFullNameAndTitle }}</div>
        <div class="email">
          <a [href]="'mailto:' + gm.grantMakerEmail">
            {{ gm.grantMakerEmail }}
          </a>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button class="close" mat-button mat-dialog-close>{{ 'SHARED.COMPONENTS.FUNDER_CARD.GRANTMAKERS.CLOSE' | translate }}</button>
  </mat-dialog-actions>
</ng-container>
<ng-template #nolist>
  <div class="nolist">{{ 'SHARED.COMPONENTS.FUNDER_CARD.GRANTMAKERS.NONE_LISTED' | translate }}</div>
  <mat-dialog-actions align="center">
    <button class="close-nolist" mat-button mat-dialog-close>{{ 'SHARED.COMPONENTS.FUNDER_CARD.GRANTMAKERS.CLOSE' | translate }}</button>
  </mat-dialog-actions>
</ng-template>
